<template>
  <zoovu-zoe-attribute
    :region="region"
    :api-key="apiKey"
    :locale="locale"
    :sku="identifier"
    :context="zoeContext"
    :attribute-name="value"
    :attribute-value="value"
    :app-key="apiKey"
    :dev="dev"
  />
</template>

<script>

export default {
	name: 'ZoeAttribute',
	props: ['identifier', 'zoeContext', 'value'],
	data() {
		return {
			region: 'eu',
			apiKey: 'ks_h6xcc37z96zTfWpMkfIhg-b8',
			locale: 'en-IE',
			dev: '',
			isDev: false
		};
	},
	beforeMount() {
		this.isDev = window.location.pathname.includes('dev');
		if (this.isDev) {
			this.region = 'us';
			this.apiKey = 'iLWXz5mQmdRrsiqhaFenDd0zm6w';
			this.locale = 'en-GB';
			this.dev = 'qa10';
		}
	}
};
</script>